import { Tabs, Breadcrumb, Space, Flex } from "antd";
import { MainLayout } from "components/layouts";
import { useTranslation } from "react-i18next";
import SettingEmailTemplateListComponent from "../components/SettingEmailTemplateList";
import useSettingEmailTemplate from "../hooks/useSettingEmailTemplate";
import EmailLoopListContent from "features/emailLoop/pages/EmailLoopListContent";
import NotificationListContent from "features/notification/pages/NotificationListContent";

const SettingEmailNotificationPage = () => {
    const { t } = useTranslation();
    const templateProps = useSettingEmailTemplate();

    const items = [
        {
            key: "notification",
            label: t("notification.header"),
            children: <NotificationListContent />,
        },
        {
            key: "template",
            label: t("setting_email_template_list.header"),
            children: <SettingEmailTemplateListComponent {...templateProps} embedded />,
        },
        {
            key: "loop",
            label: t("email_loop.header"),
            children: <EmailLoopListContent />,
        },
    ];

    return (
        <MainLayout>
            <Space direction="vertical" size={24} style={{ width: "100%" }}>
                <Flex vertical>
                    <Breadcrumb
                        items={[
                            { title: t("home.header"), href: "/" },
                            { title: t("masterdata.header"), href: "" },
                            { title: t("notification_setting.header") },
                        ]}
                    />
                    <h2>{t("notification_setting.header")}</h2>
                </Flex>
                <Tabs items={items} />
            </Space>
        </MainLayout>
    );
};

export default SettingEmailNotificationPage;